module.exports = __webpack_public_path__ + "img/menucn_5_6.c315a204.svg";